// Service pour gérer les préférences utilisateur, notamment le mode sombre
const THEME_PREFERENCE_KEY = 'theme_preference';
const ANIMATION_PREFERENCE_KEY = 'animation_preference';

// Récupérer la préférence de thème (clair/sombre)
export function getThemePreference() {
  // Vérifier si une préférence est déjà stockée
  const storedPreference = localStorage.getItem(THEME_PREFERENCE_KEY);

  if (storedPreference) {
    return storedPreference;
  }

  // Si aucune préférence n'est stockée, vérifier la préférence du système
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }

  // Par défaut, utiliser le thème clair
  return 'light';
}

// Sauvegarder la préférence de thème
export function saveThemePreference(theme) {
  localStorage.setItem(THEME_PREFERENCE_KEY, theme);

  // Appliquer le thème immédiatement
  applyTheme(theme);
}

// Appliquer le thème à l'ensemble du document
export function applyTheme(theme) {
  // Détection mobile (viewport) : on force le thème clair sur mobile
  const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 800px)').matches;
  const effectiveTheme = isMobile ? 'light' : theme;

  document.documentElement.setAttribute('data-theme', effectiveTheme);

  // Ajouter/supprimer la classe 'dark-mode' du body uniquement si non mobile
  if (effectiveTheme === 'dark') {
    document.body.classList.add('dark-mode');
  } else {
    document.body.classList.remove('dark-mode');
  }
}

// Basculer entre les thèmes clair et sombre
export function toggleTheme() {
  const currentTheme = getThemePreference();
  const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
  saveThemePreference(newTheme);
  return newTheme;
}

// Gestion des préférences d'animation
export function getAnimationPreference() {
  const storedPreference = localStorage.getItem(ANIMATION_PREFERENCE_KEY);
  return storedPreference ? storedPreference === 'true' : true; // Par défaut, les animations sont activées
}

export function saveAnimationPreference(enabled) {
  localStorage.setItem(ANIMATION_PREFERENCE_KEY, enabled.toString());

  // Appliquer immédiatement la préférence
  applyAnimationPreference(enabled);
}

export function applyAnimationPreference(enabled) {
  if (enabled) {
    document.body.classList.remove('reduced-motion');
  } else {
    document.body.classList.add('reduced-motion');
  }
}

// Initialiser les préférences au chargement
export function initializeUserPreferences() {
  const theme = getThemePreference();
  applyTheme(theme);

  const animationsEnabled = getAnimationPreference();
  applyAnimationPreference(animationsEnabled);
}
